import { ModuleWithProviders, NgModule, Provider } from '@angular/core';

import { EnvironmentOptions } from '~environments/environment-options';

import { SERVICES } from './services';
import {
  GoogleAnalyticsService,
  AnalyticsService,
  NoopAnalyticsService,
  GOOGLE_ANALYTICS_ACCOUNT_KEY
} from './services/analytics.service';

export function provideEnvironment(options?: EnvironmentOptions): Provider[] {
  return options && options.useAnalytics
    ? [
      { provide: GOOGLE_ANALYTICS_ACCOUNT_KEY, useValue: options.analyticsId },
      GoogleAnalyticsService,
      { provide: AnalyticsService, useExisting: GoogleAnalyticsService },
    ]
    : [
      { provide: GoogleAnalyticsService, useClass: NoopAnalyticsService }
    ];

}
@NgModule()
export class CoreModule {
  static forRoot(providers: Provider[]): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [...SERVICES as Provider[], ...providers]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts